export default {
  SET_USER(state, user) {
    state.id = user.id;
    state.name = user.name;
    state.amr = user.amr;
    state.uuid = user.uuid;
    state.email = user.email;
    state.username = user.username;
    state.type = user.type;
    state.photo = user.photo;
    state.timezone = user.timezone;
    state.languageId = user.languageId;
    state.accessibility = user.accessibility;
    state.temporaryPassword = user.temporaryPassword;
  },
  RESET_USER_ACCESSIBILITY(state) {
    state.accessibility = {
      darkThemeEnabled    : false,
      fontSizeEnabled     : false,
      signLanguageEnabled : false
    };
  },
  SET_USER_PASSWORD(state, password) {
    state.password = password;
  },
  SET_USER_INFO(state, user) {
    state.name          = user.name || state.name;
    state.email         = user.email || state.email;
    state.timezone      = user.timezone || state.timezone;
    state.languageId    = user.languageId || state.languageId;
    state.accessibility = user.accessibility || state.accessibility;
    state.photo         = user.photo || user.profilePhoto || state.photo;
  },
  SET_USER_PHOTO(state, photoUrl) {
    state.photo = photoUrl;
  },
  SET_USER_AVAILABLE_APPLICATIONS(state, applications) {
    state.availableApplications = applications;
  },
  SET_LANG(state, languageId) {
    state.languageId = languageId;
  },

  // v3
  SET_USER_INFO_V3(state, user) {
    state.name          = user.name ?? state.name;
    state.email         = user.email ?? state.email;
    state.timezone      = user.timezone ?? state.timezone;
    state.languageId    = user.languageId ?? state.languageId;
    state.accessibility = {
      signLanguageEnabled : user.signLanguageEnabled,
      darkThemeEnabled    : user.theme === 'dark'
    };
    state.photo         = user.profilePhoto || state.photo;
  },
  SET_CURRENT_CONTEXT(state, context) {
    state.currentContext = context;
  },
  SET_CONTEXTS(state, contexts) {
    state.contexts = contexts;
  },
  SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions;
  }
};
